module.exports = __webpack_public_path__ + "img/SHIPPING.e5012a3c.svg";